import React, { ReactElement } from 'react';
import { useDashboardSelector } from '../dashboardHooks';
import { Loader } from './Loader/Loader';

export function GlobalLoader(): ReactElement | null {
  const { show, message } = useDashboardSelector((state) => state.globalLoader);

  return show ? <Loader text={message} large fullScreen /> : null;
}
